import { Text } from "@mantine/core";
import { forwardRef } from "react";
import type { ChatTask } from "@/sdk/agent/chat";
import { formatTime } from "@/shared-utils";

import { ListItemSeparator } from "./ListItemSeparator";

// TODO: add more chat ended reasons as we know them
const StyledEndReason = ({ chatTask }: { chatTask: ChatTask }) => {
    if (chatTask.isClosedByCustomer) {
        return (
            <>
                &nbsp;-&nbsp;
                <Text size="xs" fw={700} c="yellow.6">
                    {"Closed by the customer"}
                </Text>
            </>
        );
    } else return null;
};

export const ChatEndedSeparator = forwardRef<HTMLDivElement, { chatTask: ChatTask }>(function ChatEndedSeparator(
    { chatTask },
    ref,
) {
    if (chatTask.stateLastChangedAt) {
        const endedAt = chatTask.stateLastChangedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        const duration = formatTime(
            (chatTask.stateLastChangedAt.getTime() - chatTask.dateCreated.getTime()) / 1000,
            true,
        );

        return (
            <ListItemSeparator
                label={
                    <>
                        {`Session ended - ${endedAt} | Duration ${duration}`}
                        <StyledEndReason chatTask={chatTask} />
                    </>
                }
                ref={ref}
            />
        );
    }
    return <ListItemSeparator label={`Session ended`} ref={ref} />;
});
